// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const AuthorLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.apiPage.authorLabel"
        description="Author label."
        defaultMessage="Author"
    />
);
AuthorLabel.displayName = "AuthorLabel";

export const TimeCreatedLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.apiPage.timeCreatedLabel"
        description="Time created label."
        defaultMessage="Time Created"
    />
);
TimeCreatedLabel.displayName = "TimeCreatedLabel";

export const LastEditorLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.apiPage.lastEditorLabel"
        description="Last editor label."
        defaultMessage="Last Editor"
    />
);
LastEditorLabel.displayName = "LastEditorLabel";

export const LastEditTimeLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.apiPage.lastEditTimeLabel"
        description="Last edit time label."
        defaultMessage="Last Edit Time"
    />
);
LastEditTimeLabel.displayName = "LastEditTimeLabel";

export const CopyCTA = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.apiPage.copyCTA" description="Copy ct a." defaultMessage="Copy" />
);
CopyCTA.displayName = "CopyCTA";

export const NotApplicableText = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.apiPage.notApplicableText"
        description="Not applicable text."
        defaultMessage="N/A"
    />
);
NotApplicableText.displayName = "NotApplicableText";

export const TabTitleAPISettings = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.apiPage.tabTitleAPISettings"
        description="Tab title api settings."
        defaultMessage="API Settings"
    />
);
TabTitleAPISettings.displayName = "TabTitleAPISettings";

export const TabTitleAPIKeys = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.apiPage.tabTitleAPIKeys"
        description="Tab title api keys."
        defaultMessage="API Keys"
    />
);
TabTitleAPIKeys.displayName = "TabTitleAPIKeys";
